import * as z from 'zod';
import { FINANCIAL_DOCUMENT_PRINT_TEMPLATE } from 'src/features/billing/utils/types';
import { validationMessagesMap } from 'src/utils/messages';

const billingEntityFormObject = z.object({
    name: z.string().nonempty(),
    email: z.email().optional().nullable().or(z.literal('')),
    phone: z.string().optional().nullable(),
    uic: z.string().max(32).nonempty(),
    code: z.string().max(60).nonempty(),
    tax_registration_number: z.string().max(32).nonempty(),
    city: z.string().nonempty(),
    country: z.string().nonempty(),
    address: z.string().nonempty(),
    representative: z.string().nonempty(),
    invoice_prefix: z.string().max(10).optional().nullable(),
    invoice_footer: z.string().optional().nullable(),
    financial_document_print_template: z.enum(FINANCIAL_DOCUMENT_PRINT_TEMPLATE).nonoptional(),
    financial_document_print_color: z
        .string()
        .regex(/^#([0-9A-Fa-f]{6})$/, 'Invalid hex color')
        .optional()
        .nullable(),
    financial_document_print_logo: z.instanceof(File).nullable().optional(),
});

export type BillingEntityFormSchemaValues = z.infer<typeof billingEntityFormObject>;

/**
 * A logo is required for templates that print one — unless the entity already has a logo and the
 * user did not pick a new file (editing must not demand a re-upload).
 */
export const makeBillingEntityFormSchema = ({ hasExistingLogo }: { hasExistingLogo: boolean }) =>
    billingEntityFormObject.superRefine((data, ctx) => {
        if (
            data.financial_document_print_template !== FINANCIAL_DOCUMENT_PRINT_TEMPLATE.STANDARD_NO_LOGO &&
            !data.financial_document_print_logo &&
            !hasExistingLogo
        ) {
            ctx.addIssue({
                code: 'custom',
                path: ['financial_document_print_logo'],
                message: validationMessagesMap.validationErrorRequired,
            });
        }
    });

export const billingEntityFormSchema = makeBillingEntityFormSchema({ hasExistingLogo: false });
